'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var questionnaire = function questionnaire() {
  return import('@/page/qusetionnaire');
};
var qusetionnaireresult = function qusetionnaireresult() {
  return import('@/page/qusetionnaire/qusetionnaireresult');
};
exports.default = [{
  path: '/questionnairepaper',
  name: 'questionnairepaper',
  component: questionnaire,
  childred: []
}, {
  path: '/qusetionnaireresult',
  name: 'qusetionnaireresult',
  component: qusetionnaireresult,
  childred: []
}];